import React, { ReactNode } from 'react'

import { ProductClassValues } from 'core/application/adminDashboard/benefitDetails/groupHra/benefitDesignState'
import { WizardStatus } from 'core/domain/wizard/wizard'

import Alert from 'common/components/feedback/Alert'

export const areDataValid = (sameClassForAll: boolean, classes: ProductClassValues[] | undefined): boolean => {
  if (classes === undefined) {
    return false
  }
  if (sameClassForAll && classes.length > 0 && classes[0].status === WizardStatus.Completed) {
    return true
  } else if (
    sameClassForAll === false &&
    classes.length >= 2 &&
    classes.every((item) => item.status === WizardStatus.Completed)
  ) {
    return true
  } else {
    return false
  }
}

export const getAlertContentBasedOnDesignStatus = (
  sameClassForAll: boolean | undefined,
  productClasses: undefined | ProductClassValues[],
  translate: any,
): ReactNode => {
  /* if (sameClassForAll && (!productClasses || productClasses.length === 0)) {
    return (
      <Alert
        type="info"
        showIcon
        message="Start designing the benefit for your class."
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam nisl aenean ornare nisi posuere. Amet accumsan lacus commodo suspendisse rhoncus cursus. Euismod mi sed pretium porttitor pretium massa, magna. Sit potenti amet posuere habitant faucibus."
      />
    );
  } else*/
  if (!sameClassForAll && (!productClasses || productClasses.length === 0)) {
    return (
      <Alert
        type="info"
        showIcon
        message={translate('admin-dashboard.benefit-details.class-design.multiple-classes-no-class-alert-header')}
        description={translate('admin-dashboard.benefit-details.class-design.multiple-classes-no-class-alert-desc')}
      />
    )
    /* } else if (!sameClassForAll && productClasses && productClasses.length === 1) {
    return (
      <Alert
        type="info"
        showIcon
        message="Design the benefit for your second class now"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam nisl aenean ornare nisi posuere. Amet accumsan lacus commodo suspendisse rhoncus cursus. Euismod mi sed pretium porttitor pretium massa, magna. Sit potenti amet posuere habitant faucibus."
      />
    );*/
  } else if (!sameClassForAll && productClasses && productClasses.length >= 1) {
    return (
      <Alert
        type="info"
        showIcon
        message={translate('admin-dashboard.benefit-details.class-design.multiple-classes-alert-header')}
        description={translate('admin-dashboard.benefit-details.class-design.multiple-classes-alert-desc')}
      />
    )
  } else {
    return null
  }
}

export const showDeleteAsDisabled = (
  benefitStatus: WizardStatus,
  classStatus: WizardStatus,
  classes: ProductClassValues[],
): boolean => {
  return (
    benefitStatus === WizardStatus.Completed &&
    classStatus === WizardStatus.Completed &&
    classes.filter((item) => item.status === WizardStatus.Completed).length === 2
  )
}
